import axios from "axios";
import { API_ORIGIN } from "../config/constants";

const authToken = localStorage.getItem("Authtoken");

export class LocationService {
  static provinceDetails = async () => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/cities/provinces/all",
      });
      
      let provinceDetail = response.data.data;
      return provinceDetail;
    } catch (err) {
      throw err;
    }
  };

  static districtDetails = async () => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/cities/districts/all",
      });

      let provinceDetail = response.data.data;
      return provinceDetail;
    } catch (err) {
      throw err;
    }
  };

  static cityDetails = async () => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/cities/get/all",
      });

      let cityDetail = response.data.data;
      return cityDetail;
    } catch (err) {
      throw err;
    }
  };
}
